// 更新价格显示 - 根据sale price计算分期价格
function updatePriceDisplay(variant, productId) {
  if (!variant) return;

  const price = variant.price;
  const comparePrice = variant.compare_at_price;

  // 更新常规价格
  const priceElement = document.querySelector(
    `.ProductPrice-${productId} .money`
  );
  if (priceElement) {
    priceElement.setAttribute("data-currency-usd", formatMoney(price));
    priceElement.textContent = formatMoney(price, true);
  }

  // 更新比较价格
  const comparePriceElement = document.querySelector(
    `.ComparePrice-${productId} .money`
  );
  if (comparePriceElement && comparePrice > price) {
    comparePriceElement.setAttribute(
      "data-currency-usd",
      formatMoney(comparePrice)
    );
    comparePriceElement.textContent = formatMoney(comparePrice, true);
    comparePriceElement.parentElement.style.display = "flex";
  } else if (comparePriceElement) {
    comparePriceElement.parentElement.style.display = "none";
  }

  // 隐藏折扣信息容器
  const discountContainer = document.querySelector(`[data-discount-container="${productId}"]`);
  if (discountContainer) {
    discountContainer.style.display = 'none';
  }

  // 更新所有分期付款价格 - 根据sale price计算
  const afterpayElements = document.querySelectorAll(
    ".new-price-afterpay .money"
  );
  afterpayElements.forEach(function (element) {
    const weeklyPayment = Math.round(price / 4);
    element.setAttribute("data-currency-usd", formatMoney(weeklyPayment));
    element.textContent = formatMoney(weeklyPayment, true);
  });
}

// 格式化金额
function formatMoney(cents, withSymbol = false) {
  const dollars = cents / 100;
  const formatted = dollars.toFixed(2);
  return withSymbol ? `$${formatted}` : formatted;
}

// 处理动态按钮的显示
function fixDynamicButtons() {
  // 处理原始按钮区域
  const paymentButton = document.querySelector(".shopify-payment-button");
  if (paymentButton) {
    // 移除额外的支付选项文本
    const morePaymentOptions = paymentButton.querySelector(
      ".shopify-payment-button__more-options"
    );
    if (morePaymentOptions) {
      morePaymentOptions.style.display = "none";
    }

    // 确保PayPal按钮正确显示
    const paypalButton = paymentButton.querySelector(
      ".shopify-payment-button__button--branded"
    );
    if (paypalButton) {
      paypalButton.style.minHeight = "44px";
      paypalButton.style.height = "44px";
    }

    // 确保普通Buy Now按钮正确显示
    const buyNowButton = paymentButton.querySelector(
      ".shopify-payment-button__button--unbranded"
    );
    if (buyNowButton) {
      buyNowButton.style.minHeight = "44px";
      buyNowButton.style.height = "44px";
    }
  }
}

// 初始化
document.addEventListener("DOMContentLoaded", function () {
  // 修复动态按钮显示
  fixDynamicButtons();

  // 初始更新价格
  const productForm = document.querySelector(".product-single__form");
  if (productForm) {
    const productId = productForm.querySelector('[name="product-id"]').value;
    const variantJson = document.querySelector("[data-variant-json]");
    if (variantJson) {
      const variants = JSON.parse(variantJson.textContent);
      const currentVariantJson = document.querySelector(
        "[data-current-variant-json]"
      );
      const currentVariant = currentVariantJson
        ? JSON.parse(currentVariantJson.textContent)
        : variants[0];
      updatePriceDisplay(currentVariant, productId);
    }
  }

  // 监听变体变化
  document.addEventListener("variant:change", function (e) {
    if (e.detail && e.detail.variant) {
      const variant = e.detail.variant;
      const productId = document
        .querySelector("[data-product-id]")
        .getAttribute("data-product-id");
      updatePriceDisplay(variant, productId);
    }
  });
});

// 与现有的_updatePrice函数集成
const originalUpdatePrice =
  window.theme &&
  window.theme.Product &&
  window.theme.Product.prototype._updatePrice;
if (originalUpdatePrice) {
  window.theme.Product.prototype._updatePrice = function (variant) {
    originalUpdatePrice.call(this, variant);

    // 额外更新我们的自定义价格显示
    const productId = this.container.getAttribute("data-product-id");
    if (productId) {
      updatePriceDisplay(variant, productId);
    }
  };
}